import { gql, useQuery } from "@apollo/client";
import { TenantPermissions } from "./schema/TenantPermissions";

export const tenantPermissionsQuery = gql`
  query TenantPermissions {
    tenant {
      access {
        me {
          permissions
        }
      }
    }
  }
`;
export const useTenantPermissions = () => {
  return useQuery<TenantPermissions>(tenantPermissionsQuery, {
    fetchPolicy: "cache-first"
  });
};
